export const blobToFile = (blob: Blob): File =>
  new File([blob], "analyze.png", blob);
